import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = { url: String, token: String }

  send() {
    const body = this.inputTarget.value.trim()
    if (!body) return

    this.inputTarget.value = ""
    this.inputTarget.focus()

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": this.tokenValue,
        "Accept": "text/vnd.turbo-stream.html",
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: `body=${encodeURIComponent(body)}`
    }).then(response => {
      if (response.ok) {
        return response.text().then(html => {
          Turbo.renderStreamMessage(html)
        })
      }
    })
  }
}
